export function hasParent(element, parent) {
    do {
        if (element === parent) {
            return true;
        }

        element = element ? element.parentNode : document;
    } while (element !== document);

    return false;
}

/**
 *  Element.remove() polyfill
 */
if (typeof Element !== 'undefined') {
    // ignore in node.js
    if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function () {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }
}
